import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';
type Language = 'en' | 'es';

type UIState = {
  theme: Theme;
  language: Language;
  // v1 ships Busy-mode-only. The integrated mode flag is here so screens that branch on it
  // (Today connect-banner, Dashboard variants) can be wired now and toggled in v1.1.
  hasBooking: boolean;
  bookingConnected: boolean;
  // Show / hide the floating Busy mascot helper. Default visible. Experienced
  // users can hide it from Settings → Appearance or from inside the helper
  // panel itself.
  helperVisible: boolean;
  setTheme: (t: Theme) => void;
  setLanguage: (l: Language) => void;
  setHelperVisible: (v: boolean) => void;
};

export const useUI = create<UIState>()(
  persist(
    (set) => ({
      theme: 'light',
      language: 'en',
      hasBooking: false,
      bookingConnected: false,
      helperVisible: true,
      setTheme: (theme) => set({ theme }),
      setLanguage: (language) => set({ language }),
      setHelperVisible: (helperVisible) => set({ helperVisible }),
    }),
    { name: 'busy_ui' }
  )
);

export const isIntegratedMode = (s: Pick<UIState, 'hasBooking' | 'bookingConnected'>) =>
  s.hasBooking && s.bookingConnected;
